import styled, { css } from 'styled-components'
import { colors } from '../../../styles/constants'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
`
export const MainContainer = styled.div`
  flex: 0 auto;
  width: fit-content;
  margin: 0 auto;
  zoom: .9;
`
export const HeaderInfo = styled.section`
  width: 100%;
  display: flex;
  gap: 32px;
  margin-bottom: 48px;
  flex-wrap: wrap-reverse;
`
export const Main = styled.section`
`
export const Title = styled.h2`
  color: ${colors.black};
  font-family: Open Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28.8px;
  margin-bottom: 8px;
`
export const SubTitle = styled.h3`
  color: ${colors.gray.dark};
  font-family: Open Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28.8px;
  margin-bottom: 32px;
`
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
`

export const WrapperCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  padding: 0;
  border-radius: 0.75rem;
  flex: 1;
  gap: 1rem;
  position: relative;
  height: 100%;

  ${({ isEnable }) => !isEnable && css`
    ${CardImage} {
      background-color: #F8F9FA;
    }
    ${CardTitle},
    ${CardSubtitle} {
      color: #747576;
    }
    ${StyledActionButton} {
      font-family: Open Sans;
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      color: #CE9400;
      background-color: #FAECCA;
      border-radius: 8px;
      padding: 2px 8px;
    }
  `}
`
export const CardImage = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background-color: #FFF2EE;
`
export const CardTitle = styled.p`
  color: ${colors.black};
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.2px;
  margin: 0;
  padding: 0;
`
export const CardSubtitle = styled.p`
  width: 153px;
  color: ${colors.black};
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding: 0;
`
export const StyledActionButton = styled.button`
  color: #028BB7;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  background-color: transparent;
  margin-bottom: 8px;
`

export const GoTo = styled(Link)`
`
